import { environment } from 'environments/environment';

export const resolveImageUrl = (imageUrl?: string | string[]): string | undefined => {
    if (!imageUrl) return undefined;

    const url = Array.isArray(imageUrl) ? imageUrl[0] : imageUrl;
    if (!url) return undefined;

    const trimmed = url.trim();
    if (!trimmed) return undefined;

    if (/^(https?:|data:|blob:)/i.test(trimmed)) {
        return trimmed;
    }

    const baseUrl = environment.BASE_URL ? environment.BASE_URL.replace(/\/$/, '') : '';
    const normalizedPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

    if (!baseUrl) {
        return normalizedPath;
    }

    const basePath = baseUrl.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '');
    if (basePath && normalizedPath.startsWith(basePath)) {
        const hostPart = baseUrl.slice(0, baseUrl.length - basePath.length);
        return `${hostPart}${normalizedPath}`;
    }

    return `${baseUrl}${normalizedPath}`;
};
